import { getDefaultParameters } from "@utils/getDefaultParameters";
import { useNavigate } from "react-router-dom";

export interface onNavigateProps {
    path?: string;
    params?: Record<string, unknown>;
}

export const useNewNavigate = () => {
    const navigate = useNavigate();

    const onNavigate = ({ path, params }: onNavigateProps) => {
        const defaultParams = getDefaultParameters();

        const mergedParams = { ...defaultParams, ...params };
        const searchParams = new URLSearchParams(mergedParams);
        navigate(`${path ?? ""}?${searchParams?.toString()}`);
    };

    return { onNavigate };
};
